import { useState } from 'react';
import { FlexSpacer } from 'ui/flexSpacer/FlexSpacer';
import { Container } from 'ui/container/Container';
import { Divider } from 'ui/divider/Divider';
import { RelativeTime } from 'ui/utility/relativeTime';
import { SegmentedControl } from 'ui/segmentedControl/SegmentedControl';
import { ContentRestoreButton } from '../ContentRestoreButton';
import { InAppContainerStyle } from './ContentPreviewInApp.styled';
import { PreviewInbox } from './PreviewInbox';
import { StyledIframeFullDoc, StyledDL } from '../ContentPreview.styled';
import { getViewOptions, generatePositionStyles } from './utils';
import type { TemplateDiffContentPreviewProps, TemplateDiffContentInApp } from '../../../types';

type ContentPreviewInAppProps = TemplateDiffContentInApp & TemplateDiffContentPreviewProps;

export const ContentPreviewInApp = ({
  onClick,
  templateId,
  ...content
}: ContentPreviewInAppProps) => {
  const [previewViewOption, setPreviewViewOption] = useState<'app' | 'web' | 'inbox'>('app');
  const viewOptions = getViewOptions(!!content.inboxMetadata);
  const positionStyles = generatePositionStyles(previewViewOption === 'web')[
    content.webInAppDisplaySettings.position
  ];

  return (
    <Container size="medium" variant="primary" shadow="small">
      <FlexSpacer flexDirection="column" alignItems="stretch" gap="actionGap">
        <FlexSpacer justifyContent="space-between" alignItems="baseline">
          <StyledDL>
            <dt>Created</dt>
            <dd>
              <RelativeTime timestamp={content.createdAt} />
            </dd>
            <dt>Created by</dt>
            <dd>{content.creatorUserId}</dd>
          </StyledDL>
          <ContentRestoreButton contentId={content.id} onClick={() => onClick(content)} />
        </FlexSpacer>
        <InAppContainerStyle data-preview-view={previewViewOption}>
          {previewViewOption === 'app' && (
            <StyledIframeFullDoc
              testId="message-preview-app-iframe"
              style={{
                maxWidth: `100%`,
                position: `absolute`,
                minWidth: `100%`,
                ...positionStyles,
              }}
            >
              {content.html}
            </StyledIframeFullDoc>
          )}
          {previewViewOption === 'web' && (
            <StyledIframeFullDoc
              testId="message-preview-web-iframe"
              style={{
                maxWidth: `100%`,
                position: `absolute`,
                minWidth: `100%`,
                ...positionStyles,
              }}
            >
              {content.html}
            </StyledIframeFullDoc>
          )}
          {previewViewOption === 'inbox' && <PreviewInbox inboxMetadata={content.inboxMetadata} />}
        </InAppContainerStyle>
        <Divider />
        <FlexSpacer justifyContent="flex-start">
          <SegmentedControl
            data-test="template-editor-in-app-segmented-control"
            onSelect={setPreviewViewOption}
            options={viewOptions}
            value={previewViewOption}
          />
        </FlexSpacer>
      </FlexSpacer>
    </Container>
  );
};
